<template>
  <div>
    <v-app-bar app clipped-left class="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-spacer></v-spacer>

      <Title class="hidden-md-and-up"></Title>

      <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :close-on-click="false"
          :nudge-width="450"
          origin="top right"
          transition="scale-transition"
          bottom
          v-if="messages.length > 0"
      >
        <template v-slot:activator="{ on }">
          <v-btn
              icon
              v-on="on"
              class="ml-3"
          >
            <v-icon>mdi-bell</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item>

              <v-list-item-content>
                <v-list-item-title class="title">Import in progress...</v-list-item-title>
                <v-list-item-subtitle>During import data may be incomplete</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-progress-circular
                    indeterminate
                    color="primary"
                ></v-progress-circular>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-card-text class="card-list" ref="scroll">
            <v-list dense>
              <transition-group name="slide-fade">
                <v-list-item
                    v-for="(msg, i) in messages"
                    :key="`key-${i}`"
                >
                  <v-list-item-content>{{msg}}</v-list-item-content>
                </v-list-item>
              </transition-group>
            </v-list>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" text @click="dismissMenu">Dismiss</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
        v-model="drawer"
        clipped
        fixed
        app
    >

      <v-list
        nav
      >
        <v-list-item
            v-for="item in items"
            :key="item.title"
            link
            :to="item.link"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>

        <v-list>
          <v-list-item @click.stop.prevent="toggleTheme">
            <template v-slot:default>
              <v-list-item-action>
                <v-switch
                    :input-value="darkTheme"
                    color="primary"
                ></v-switch>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>Dark Theme</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
  import { mapMutations, mapState } from 'vuex';
  import io from 'socket.io-client';
  import Title from './Title';

  export default {
    name: 'Navbar',
    components: {
      Title
    },
    data() {
      return {
        drawer: null,
        menu: false,
        menuDismissed: false,
        messages: [],
        items: [
          { title: 'Home', icon: 'mdi-home-outline', link: '/' },
          { title: 'Search Output', icon: 'mdi-magnify', link: '/result' },
          { title: 'Output Description', icon: 'mdi-information-outline', link: '/description' },
          { title: 'FAQs', icon: 'mdi-help', link: '/faq' },
          { title: 'Downloads', icon: 'mdi-download-outline', link: '/download' },
          { title: 'Links', icon: 'mdi-link', link: '/link' },
          { title: 'Contact Us', icon: 'mdi-contact-mail-outline', link: '/contact' },
        ],
        socket: null
      }
    },
    watch: {
      messages() {
        let el = this.$refs.scroll;
        this.$nextTick(() => {
          if (el && ((el.scrollHeight - el.scrollTop) <= (el.offsetHeight + 50))) {
            el.scrollTop = el.scrollHeight
          }
        });
      }
    },
    computed: {
      ...mapState([
        'darkTheme'
      ])
    },
    mounted() {
      this.socket = io();
      this.socket.on('log', msg => {
        if (!this.menu && !this.menuDismissed) {
          this.menu = true;
        }
        this.messages.push(msg);
      });
    },
    methods: {
    ...mapMutations({
        toggleTheme: 'TOGGLE_THEME'
      }),
      dismissMenu() {
        this.menuDismissed = true;
        this.menu = false;
      }
    }
  }
</script>

<style scoped>
  .card-list {
    max-height: 400px;
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>